var _rect, _rect2, _g, _ellipse, _path, _rect3, _rect4, _rect5, _circle, _path2, _path3, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFeedbackLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 86,
    viewBox: "0 0 101 86",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 86,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    transform: "translate(-997 -421)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -24,
    width: 260,
    height: 200,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -79,
    y: -23,
    width: 258,
    height: 198,
    rx: 3,
    stroke: "#5D5CF5",
    strokeWidth: 2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.3324,
    cy: 42.6594,
    rx: 38,
    ry: 53.5,
    transform: "rotate(-60 50.3324 42.6594)",
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9862 61.5763C67.4273 62.4457 79.6668 54.3053 80.3237 43.3942C80.9806 32.4831 69.8062 22.9331 55.365 22.0636C40.9239 21.1942 28.6844 29.3346 28.0275 40.2457C27.5155 48.7515 34.1932 56.4301 44.0036 59.8141C43.5799 61.8657 42.707 65.2857 41.6547 67.0395C43.9042 66.2897 48.7447 64.2174 51.7319 61.4783C52.1471 61.5182 52.5653 61.5509 52.9862 61.5763Z",
    fill: "#62B498"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1543,
    y: 33.8105,
    width: 29,
    height: 2,
    rx: 1,
    fill: "#F3F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1543,
    y: 39.8105,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#F3F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1543,
    y: 45.8105,
    width: 29,
    height: 2,
    rx: 1,
    fill: "#F3F3F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 29,
    r: 10.75,
    fill: "white",
    stroke: "#F2AE43",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2877 27.1248L32.056 27.2114C32.478 26.76 32.7789 25.707 32.4505 24.4625C32.4078 24.3298 32.328 24.2122 32.2205 24.1236C32.1129 24.0349 31.9822 23.979 31.8438 23.9623C31.6631 23.9293 31.4767 23.9674 31.3235 24.0687C31.1703 24.17 31.0623 24.3266 31.0221 24.5057C30.7763 25.5086 30.0217 27.4764 27.8872 27.3213L27.3081 27.7539L27.7019 33.1058L28.6099 33.1731C28.9529 33.2233 30.9036 33.4772 32.1557 33.6598C32.8899 33.7545 33.6329 33.5722 34.2397 33.1486C34.8465 32.725 35.2734 32.0905 35.437 31.3691L35.7958 29.064C35.8295 28.8444 35.8172 28.6202 35.7599 28.4055C35.7025 28.1908 35.6012 27.9904 35.4625 27.8167C35.3237 27.6431 35.1505 27.5001 34.9537 27.3967C34.7569 27.2932 34.5408 27.2317 34.319 27.2159L33.2877 27.1248Z",
    fill: "#A6C1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6977 33.8099L27.4147 33.7721C27.6765 33.7664 27.884 33.5497 27.8782 33.2881L27.7522 27.5648C27.7465 27.3033 27.5296 27.0959 27.2679 27.1016L25.5509 27.1394C25.2891 27.1451 25.0816 27.3618 25.0873 27.6234L25.2133 33.3467C25.2191 33.6083 25.436 33.8156 25.6977 33.8099Z",
    fill: "#7596E3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -4307.5,
    y: -2100.5,
    width: 22802,
    height: 4952,
    stroke: "white",
    strokeWidth: 51
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_80",
    x: -84,
    y: -28,
    width: 268,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_80",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFeedbackLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/feedback-logo.eae16789.svg";
export { ForwardRef as ReactComponent };